/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './NavigationTabs.scss'
import React from 'react'
import history from '../../../util/history'

function NavigationTabs(props) {
  const replace = props.replace || false
  return (
    <div>
      <div className="scrollmenu">
        {props.tabs
          ? props.tabs.map(v => (
              <NavigationTab key={v.label} to={v.url} params={props.params} replace={replace}>
                {v.label}
              </NavigationTab>
            ))
          : null}
      </div>
      <div>{props.children}</div>
    </div>
  )
}

function NavigationTab(props) {
  const className = props.className || ''
  const to = props.to || ''
  const pathname = window.location.pathname || ''
  const currentPath = pathname.replace(/\/$/, '')
  const toPath = to.replace(/\/$/, '')
  const active = currentPath.startsWith(toPath) ? true : false
  const onClick = e => {
    e.preventDefault()
    e.stopPropagation()
    if (props.replace) {
      history.replace(props.to, props.params)
    } else {
      history.push(props.to, props.params)
    }
  }

  return (
    <div className={`NavigationTab ${className} ${active ? 'NavigationTab--active' : ''}`}>
      <a href={props.to} className={`NavigationTab__Link ${active ? 'NavigationTab__Link--active' : ''}`} onClick={onClick}>
        {props.children}
      </a>
    </div>
  )
}
export default NavigationTabs
